import React from 'react'

import { Popover, Select, Typography } from 'antd'

import { getMessage } from '../../../../../../util/IntlMessages'
import { useGetSelectOptionsQuery } from '../../services/selectOption'
import { useSelectOptionsContext } from '../../context/selectOptions'

import './styles.less'

export function ManageOptionRelationshipsPopover({ children, option, selectedFieldId, visible }) {
  const { fieldRelationships, relatedFieldIds, fields, optionRelationships, manageSelectOptionRelationship } =
    useSelectOptionsContext()

  return (
    <Popover
      visible={visible}
      transitionName="none"
      destroyTooltipOnHide={true}
      overlayClassName="optionRelationships"
      content={
        <div className="optionRelationships__wrapper">
          {relatedFieldIds.map((fieldId) => {
            const fieldName = fields.entities[fieldId]?.fieldName
            const fieldRelationshipId = fieldRelationships[fieldId]

            const key = `${fieldRelationshipId}_${option?.id}`
            const relatedOptionId = (optionRelationships && optionRelationships.entities[key]?.relatedOptionId) || null

            const { data: options, isLoading } = useGetSelectOptionsQuery({ fieldId })

            return (
              <div className="optionRelationships__selectWrapper" key={fieldId}>
                <Typography.Text>
                  {fieldName}
                  <span className="optionRelationships__unrelated">{!relatedOptionId && ' *'}</span>
                </Typography.Text>

                <Select
                  showSearch
                  allowClear
                  loading={isLoading}
                  value={relatedOptionId}
                  placeholder={getMessage('select')}
                  onChange={(value) =>
                    manageSelectOptionRelationship({
                      mainOptionId: option.id,
                      relatedOptionId: value,
                      fieldRelationshipId,
                      fieldId: selectedFieldId
                    })
                  }
                  filterOption={(input, option) => option.props.label.toLowerCase().startsWith(input.toLowerCase())}
                >
                  {options?.ids.map((optionId) => (
                    <Select.Option key={optionId} value={optionId} label={options.entities[optionId].description}>
                      {options.entities[optionId].description}
                    </Select.Option>
                  ))}
                </Select>
              </div>
            )
          })}
        </div>
      }
      placement="bottomLeft"
      arrowPointAtCenter={true}
    >
      {children}
    </Popover>
  )
}
